// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-divider[data-v-117da6d9] {\n  margin: 0 0 1.2rem 0;\n}\n.desc-width[data-v-117da6d9] {\n  width: 50%;\n}\narticle.tile.is-child > .columns .column i.icon[data-v-117da6d9] {\n  color: #1a5276;\n}\n.modal-card-title[data-v-117da6d9] {\n  color: #1a5276;\n  font-weight: 600;\n  line-height: 1.125;\n}\ndiv.tile.is-parent[data-v-117da6d9] {\n  min-height: calc(100vh - 18rem);\n}", ""]);
// Exports
module.exports = exports;
